import { render, staticRenderFns } from "./WorkerNotes.vue?vue&type=template&id=3588f450&scoped=true&"
import script from "./WorkerNotes.vue?vue&type=script&lang=js&"
export * from "./WorkerNotes.vue?vue&type=script&lang=js&"
import style0 from "./WorkerNotes.vue?vue&type=style&index=0&id=3588f450&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3588f450",
  null
  
)

export default component.exports